import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="about-page">
      <section className="py-24">
        <div className="max-w-[1200px] mx-auto px-6">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold font-manrope mb-6">
              About <span className="text-primary">SerendiTech</span>
            </h1>
            <p className="text-muted-foreground text-lg max-w-3xl mx-auto leading-relaxed">
              Combining serendipity with technology to help businesses discover innovative solutions that transform operations and unlock data-driven insights.
            </p>
          </motion.div>

          <motion.div
            className="grid md:grid-cols-2 gap-12 items-center mb-20"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div>
              <div
                className="rounded-2xl overflow-hidden h-[400px] bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1758873269317-51888e824b28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWFtJTIwbWVldGluZyUyMGRpdmVyc2V8ZW58MHx8fHwxNzcxODI5MDYyfDA&ixlib=rb-4.1.0&q=85')`,
                }}
              />
            </div>

            <div className="space-y-6">
              <p className="text-muted-foreground text-base leading-relaxed">
                SerendiTech is a comprehensive digital transformation and data solutions provider, dedicated to helping organizations accelerate their technology journey. Our name combines "Serendipity" — the art of making fortunate discoveries — with "Technology", reflecting our mission to help businesses discover innovative solutions.
              </p>
              <p className="text-muted-foreground text-base leading-relaxed">
                We specialize in three core areas: <span className="text-primary font-semibold">Microsoft Power Platform solutions</span> for rapid low-code development, <span className="text-primary font-semibold">custom software development</span> for complex business requirements, and <span className="text-primary font-semibold">comprehensive data services</span> including data warehousing, Azure Databricks, and advanced analytics.
              </p>
              <p className="text-muted-foreground text-base leading-relaxed">
                Our team of certified specialists partners with organizations across diverse industries to design, build, and deploy solutions that drive efficiency, unlock insights, and create sustainable competitive advantage.
              </p>
            </div>
          </motion.div>

          <motion.div
            className="grid md:grid-cols-2 gap-8"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div className="bg-card p-8 rounded-2xl border-l-4 border-primary">
              <h3 className="text-primary text-2xl font-bold font-manrope mb-4">Our Mission</h3>
              <p className="text-muted-foreground leading-relaxed">
                To empower organizations with intelligent automation, custom solutions, and data-driven insights that unlock efficiency, drive innovation, and create sustainable competitive advantage.
              </p>
            </div>

            <div className="bg-card p-8 rounded-2xl border-l-4 border-primary">
              <h3 className="text-primary text-2xl font-bold font-manrope mb-4">Our Vision</h3>
              <p className="text-muted-foreground leading-relaxed">
                To be the region's most trusted technology partner, recognized for delivering transformative digital and data solutions that enable businesses to thrive in the modern economy.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;